import { useState } from "react";
import FollowUpTypeChip from "./FollowUpTypeChip";
import Swal from "sweetalert2";
import { Chip } from "@mui/material";

// Create a small wrapper component for the cell
export const FollowUpTypeCell = ({
  row,
  handleFollowUpTypeChange,
  canChange = true,
}: {
  row: any;
  handleFollowUpTypeChange: (id: string, followUpType: string) => void;
  canChange?: boolean;
}) => {
  const [followUpType, setFollowUpType] = useState(
    row.original.follow_up_type || ""
  );

  const onChange = (newType: string) => {
    if (row.original.is_deleted) {
      Swal.fire({
        text: "You Cannot Change the Follow Up Type of a Trashed Quotation.",
        icon: "warning",
        confirmButtonText: "Okay!",
        confirmButtonColor: "#d33",
        width: "250px",
        padding: "0.5rem",
        customClass: {
          popup: "swal2-sm-popup",
          confirmButton: "swal2-sm-btn",
        },
      });
      return;
    }
    setFollowUpType(newType);
    handleFollowUpTypeChange(row.original.quotation_id, newType);
  };

  // Render non-editable type for deleted quotations
  if (row.original.is_deleted || !canChange) {
    const typeColors: Record<
      string,
      { bg: string; text: string; border: string }
    > = {
      Whatsapp: { bg: "#e8f5e9", text: "#2e7d32", border: "#2e7d32" },
      Email: { bg: "#e3f2fd", text: "#1565c0", border: "#1565c0" },
      Call: { bg: "#fff3e0", text: "#e65100", border: "#e65100" },
    };

    const currentColors = followUpType
      ? typeColors[followUpType] || { bg: "#f5f5f5", text: "#757575", border: "#bdbdbd" }
      : { bg: "#f5f5f5", text: "#757575", border: "#bdbdbd" };

    return (
      <Chip
        label={followUpType || "NA"}
        size="small"
        sx={{
          width: "90px",
          backgroundColor: currentColors.bg,
          color: currentColors.text,
          border: `1px solid ${currentColors.border}`,
          fontWeight: 600,
          fontSize: "0.7rem",
          height: "24px",
          borderRadius: "16px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          "& .MuiChip-label": {
            padding: "0 8px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          },
        }}
      />
    );
  }

  return <FollowUpTypeChip initialType={followUpType} onChange={onChange} />;
};

